const CommonStyles = {
  THEME_COLOR: '#284CB0',
  SUB_MENU_COLOR: '#0572EF',
  Colors: {
    primary: '#284CB0'
  }
};

export default CommonStyles;
